import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import Header from './components/Header';
import Hero from './components/Hero';
import Problem from './components/Problem';
import Features from './components/Features';
import AIOperations from './components/AIOperations';
import Benefits from './components/Benefits';
import Trust from './components/Trust';
import Workflow from './components/Workflow';
import FAQ from './components/FAQ';
import FloatingAssistant from './components/FloatingAssistant';
import Footer from './components/Footer';
import ScrollIndicator from './components/ScrollIndicator';

function App() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-dark-950 via-dark-900 to-dark-800 relative">
      <ScrollIndicator />
      
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: isLoaded ? 1 : 0 }}
        transition={{ duration: 1 }}
        className="relative"
      >
        <Header />
        <Hero />
        <Problem />
        <Features />
        <AIOperations />
        <Benefits />
        <Trust />
        <Workflow />
        <FAQ />
        <Footer />
        <FloatingAssistant />
      </motion.div>
    </div>
  );
}

export default App; 